/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_DatePicker = _resolveComponent("DatePicker");
  return _openBlock(), _createBlock(_component_DatePicker, {
    "model-value": $data.time,
    options: $props.options,
    type: $props.type,
    format: $props.format,
    placeholder: $props.placeholder,
    onOnChange: $options.handleChange,
    style: {
      "width": "100%"
    }
  }, null, 8 /* PROPS */, ["model-value", "options", "type", "format", "placeholder", "onOnChange"]);
}